import { render, staticRenderFns } from "./CompleteTournamentMiniBlock.vue?vue&type=template&id=abbc273c&scoped=true"
import script from "./CompleteTournamentMiniBlock.vue?vue&type=script&lang=js"
export * from "./CompleteTournamentMiniBlock.vue?vue&type=script&lang=js"
import style0 from "./CompleteTournamentMiniBlock.vue?vue&type=style&index=0&id=abbc273c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbc273c",
  null
  
)

export default component.exports